const ISO_CURRENCY_RE = /^[A-Z]{3}$/;

export function formatAmount(amount: number, currency: string): string {
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const normalized = typeof currency === 'string' ? currency.trim().toUpperCase() : '';

  if (ISO_CURRENCY_RE.test(normalized)) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: normalized,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(safeAmount);
    } catch {
      // fall through to plain number formatting
    }
  }

  const plain = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safeAmount);

  return normalized ? `${plain} ${normalized}` : plain;
}
